import { api } from "../api";

/** A Direct Data chega a levar ~17s; o backend desiste em 35s, entao 45s garante que o front sempre receba resposta. */
const DIRECTD_TIMEOUT_MS = 45000;

/**
 * findVehicleDirectdByPlate - Function that looks up the plate on Direct Data (cached for 30 days on the backend)
 * /vehicles/directd/{plate}
 * method GET
 * @async-function
 */
const findVehicleDirectdByPlate = async (token: string, plate: string) => {
    const response = await api.get(
        `/vehicles/directd/${encodeURIComponent(plate)}`, {
            timeout: DIRECTD_TIMEOUT_MS,
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default findVehicleDirectdByPlate;
